import React from "react";
import DefaultLayout from "@/app/components/layouts/DefaultLayout";
import WhyChooseUsPage from '@/app/components/templates/whyChooseUsPage/WhyChooseUsPage';

const WhyChooseUs = props => {
  return (
    <DefaultLayout>
      <WhyChooseUsPage/>
    </DefaultLayout>
  );
};

export default WhyChooseUs;